export default __webpack_public_path__ + "static/link-item-dont-833c6cb5758545f479bd1adb816da931.png";